export const analyticsId = {
  BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW: 'BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW',
  BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_VIEW: 'BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_VIEW',
  BROKER_INTERNAL_TRANSFER_CONTRIBUTION_STEP_VIEW: 'BROKER_INTERNAL_TRANSFER_CONTRIBUTION_STEP_VIEW',
  BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_SUCCESS: 'BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_SUCCESS',
  BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_SUCCESS: 'BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_SUCCESS',
  BROKER_INTERNAL_TRANSFER_FUNDS_ERROR: 'BROKER_INTERNAL_TRANSFER_FUNDS_ERROR',
  BROKER_INTERNAL_TRANSFER_FUNDS_SUCCESS: 'BROKER_INTERNAL_TRANSFER_FUNDS_SUCCESS',
};

const commonFields = productName => ({
  sectionFamily: 'wealth',
  sectionCategory: 'products',
  sectionName: 'funds',
  serviceType: 'productContracting',
  interactionType: 'funnel',
  processType: 'sellFunds',
  productName,
});

export const catalogue = {
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_VIEW]: ({ productName, stepNumber }) => ({
    ...commonFields(productName),
    event_name: 'step_investment_details',
    pageName: `/sellFunds/step${stepNumber}/investmentDetails`,
    processStep: 'step' + stepNumber,
    processDetail: 'investmentDetails',
  }),
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_VIEW]: ({ productName, stepNumber }) => ({
    ...commonFields(productName),
    event_name: 'step_terms_conditions',
    pageName: `/sellFunds/step${stepNumber}/termsConditions`,
    processStep: 'step' + stepNumber,
    processDetail: 'termsConditions',
  }),
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_1_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'investmentDetails',
  }),
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_STEP_2_SUCCESS]: () => ({
    event_name: 'event_success',
    action: 'success',
    format: 'steps',
    component: 'funnel',
    element: 'termsConditions',
  }),
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_ERROR]: ({ productName, errorMessage }) => ({
    ...commonFields(productName),
    event_name: 'step_error',
    pageName: '/sellFunds/error/genericError',
    processStep: 'error',
    processDetail: 'genericError',
    errorCategory: 'genericError',
    errorDescription: errorMessage,
  }),
  [analyticsId.BROKER_INTERNAL_TRANSFER_FUNDS_SUCCESS]: ({ productName, amount }) => ({
    ...commonFields(productName),
    event_name: 'step_success',
    pageName: '/sellFunds/success',
    processStep: 'success',
    amount: amount
  }),
  footerButtons: ({ stepName, productName, isin, buttonNextTag }) => ({
    next: {
      data: true,
      categoriaEvento: 'transfer/fund',
      accionEvento: stepName,
      etiquetaEvento: buttonNextTag,
      productName: productName,
      productID: isin,
    },
    previous: {
      data: true,
      categoriaEvento: 'transfer/fund',
      accionEvento: stepName,
      etiquetaEvento: 'anterior',
      productName: productName,
      productID: isin,
    },
    cancel: {
      data: true,
      categoriaEvento: 'transfer/fund',
      accionEvento: stepName,
      etiquetaEvento: 'cancelar',
      productName: productName,
      productID: isin,
    },
    finish: {
      data: true,
      categoriaEvento: 'transfer/fund',
      accionEvento: stepName,
      etiquetaEvento: 'comprar',
      productName: productName,
      productID: isin,
    },
  }),
};
